import QRCode from "react-qr-code";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Download, Printer } from "lucide-react";

interface QRCodeCardProps {
  businessName: string;
  staffName: string;
  url: string;
  brandColor?: string;
}

export function QRCodeCard({ businessName, staffName, url, brandColor = "#3B82F6" }: QRCodeCardProps) {
  const handleDownload = () => {
    const svg = document.getElementById("qr-code-svg");
    if (!svg) return;
    
    const svgData = new XMLSerializer().serializeToString(svg);
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const img = new Image();
    
    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx?.drawImage(img, 0, 0);
      const pngFile = canvas.toDataURL("image/png");
      const downloadLink = document.createElement("a");
      downloadLink.download = `${staffName.replace(/\s+/g, "-")}-qr-code.png`;
      downloadLink.href = pngFile;
      downloadLink.click();
    };
    
    img.src = "data:image/svg+xml;base64," + btoa(svgData);
  };

  const handlePrint = () => {
    window.print();
  };

  return (
    <Card className="max-w-sm print:shadow-none print:border-0" data-testid="qr-code-card">
      <CardHeader className="text-center pb-2">
        <div
          className="h-2 rounded-t-md -mt-6 -mx-6 mb-4"
          style={{ backgroundColor: brandColor }}
        />
        <CardTitle className="text-lg">{businessName}</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col items-center gap-4">
        <div className="bg-white p-4 rounded-md">
          <QRCode
            id="qr-code-svg"
            value={url}
            size={180}
            level="M"
            fgColor="#000000"
          />
        </div>
        <p className="text-center text-muted-foreground">
          Scan to leave a review for
        </p>
        <p className="font-medium text-lg">{staffName}</p>
        <div className="flex gap-2 w-full print:hidden">
          <Button
            variant="outline"
            className="flex-1"
            onClick={handleDownload}
            data-testid="button-download-qr"
          >
            <Download className="h-4 w-4 mr-2" />
            Download
          </Button>
          <Button
            variant="outline"
            className="flex-1"
            onClick={handlePrint}
            data-testid="button-print-qr"
          >
            <Printer className="h-4 w-4 mr-2" />
            Print
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
